// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [id_pegawai, setIdPegawai] = useState(localStorage.getItem("id_pegawai"));

  const [telegram_chat_id, setTelegramID] = useState(localStorage.getItem("telegram_chat_id"));
  const [role, setRole] = useState(localStorage.getItem("role"));

  const login = ({ token, role,id_pegawai, telegram_chat_id }) => {
    localStorage.setItem("token", token);
    localStorage.setItem("role", role);
    localStorage.setItem("id_pegawai", id_pegawai);
    localStorage.setItem("telegram_chat_id", telegram_chat_id);

    setToken(token);
    setRole(role);
    setIdPegawai(id_pegawai);
    setTelegramID(telegram_chat_id);
  };

    const getRedirectByRole = (role) => {
      switch (role) {
        case "admin":
          return "/admin/default";
        case "teknisi":
          return "/admin/dashboard-teknisi";
        case "karyawan":
          return "/admin/dashboard_karyawan";
        default:
          return "/auth/sign-in";
      }
    };

  const logout = () => {
    localStorage.clear();
    setToken(null);
    setRole(null);
  };
  const getDashboardPath = () => {
    return getRedirectByRole(role || localStorage.getItem("role"));
  };
  return (
    <AuthContext.Provider value={{ token, role, id_pegawai, login, logout ,getDashboardPath ,getRedirectByRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);